import { Label as Lbl, LabelProps } from '@apia/theme';

const Label = ({ variant, ...props }: LabelProps) => (
  <Lbl sx={{ variant }} {...props} />
);

export default Label;
